module.exports = __webpack_public_path__ + "static/media/temperature.062dc781.png";